import Vue from 'vue';
import { env, Runtime } from '@/common/env';
import Horn from '@mtfe/horn-sdk';
import { monitor } from '@/common/monitor';
import { dcepCommonConfig } from '../pages/bikeactivity/config/dcepCommonConfig';
import { guideForSceneConfig } from '../pages/bikeactivity/config/guideForSceneConfig';
import { modalConfig } from '../pages/bikeactivity/config/modalConfig';

class HornInit {
  constructor() {
    Horn.init({
      deviceType: env.system,
      osVersion: env.osVersion,
      appVersion: env.commonParams.version,
      packageName: env.commonParams.app,
      token: env.commonParams.token,
      id: env.commonParams.uuid,
    }, {
      isDev: env.runtime !== Runtime.Prod
    });
  }
  fetch(url: string, params: any, defaultValue: any) {
    return Horn.fetch(url, params, defaultValue).then((res) => {
      if (!res) {
        monitor.captureMessage({
          name: url,
          msg: JSON.stringify('返回配置为空')
        });
      }
      return res;
    }).catch((err) => {
      monitor.captureMessage({
        name: url,
        msg: JSON.stringify(err)
      });
    });
  }
}

export const horn = new HornInit();

export function fetchGuideForSceneConfig(scene: any) {
  return horn.fetch('guideForSceneConfig', scene, guideForSceneConfig);
}

export function fetchDcepCommonConfig() {
  return horn.fetch('dcepCommonConfig', {}, dcepCommonConfig);
}

export function fetchDcepModalConfig() {
  return horn.fetch('dcepModalConfig', {}, modalConfig);
}

export function fetchLowCarbonSceneConfigForLC() {
  return horn.fetch('lowCarbonSceneConfigForLC', {}, []);
}
export function fetchLowCarbonSceneListConfig() {
  return horn.fetch('lowCarbonSceneList', {}, []);
}
// 获取攻略步骤内容配置
export function fetchGuideStepContent() {
  return horn.fetch('guideDetailStepsConfig', {}, {});
}
// 获取攻略页活动内容配置
export function fetchGuideContentForAct() {
  return horn.fetch('guideContentForActivity', {}, {});
}
declare module 'vue/types/vue' {
  interface Vue {
    $horn: typeof horn;
  }
}

Vue.prototype.$horn = horn;
